var map = {
	"./SCP_Studio_Collect_Logo_White.png": 480,
	"./VEVA-Cube-Glow (copy).png": 481,
	"./VEVA-Cube-Glow.png": 482,
	"./login-background.jpg": 483,
	"./logo-veva.svg": 195,
	"./logo.veva-collect-white.png": 484,
	"./new-logo.png": 121,
	"./ph.hero.projects.jpg": 485,
	"./ph.j+y.background.jpg": 486,
	"./ph.j+y.thumbnail.jpg": 487,
	"./ph.samokell.jpg": 488,
	"./studio-collect.svg": 489,
	"./user-icon.png": 490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;